import React from 'react';

import { ConstantPermissions } from 'contexts/useConstant';
import PaymentRealizedSharedFile from './PaymentRealizedSharedFile';

export default function PaymentRealizedReceived() {
  return (
    <PaymentRealizedSharedFile
      type="C"
      title="Listado de recibos procesados"
      excelName="Pagos-efectuados-de-clientes"
      entity="pymt/received-payment"
      permission={ConstantPermissions.PYMT_RECEIVED_PAYMENTS_SHOW}
      destroyPermission={ConstantPermissions.PYMT_RECEIVED_PAYMENTS_DESTROY}
    />
  );
}
